import React, { useContext, useState, useEffect } from "react";
import "./FeedbackPopup.scss";
import AppContext from "../../config/AppContext";
import DescriptionInputFeedback from "./DescriptionFeedbackPopup";
import { sidebarContext } from "../../util/context";
import { cancelSubscription } from "../../services/Subscription";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import { useTranslation } from "react-i18next";
import Radio from "@mui/material/Radio";
import { toast } from "sonner";
import {Checkbox} from "@mui/material";

const FeedbackPopup = ({
  open,
  onClose,
  onConfirm,
  onFailure,
  title,
  content,
  confirmText,
  cancelText,
  selectedReason,
  setSelectedReason,
  otherReason,
  setOtherReason,
}) => {
  const { mode } = useContext(AppContext);
  const [error, setError] = useState(false);
  const { t, i18n } = useTranslation();
  const { subscriptionDetails } = useContext(sidebarContext);

  const subscriptionId = (subscriptionDetails && subscriptionDetails?.id) || "";
  const planInterval =
    (subscriptionDetails && subscriptionDetails?.plan?.intervalUnit) || "";

  const [selectedReasons, setSelectedReasons] = useState([]);
  const [reasons, setReasons] = useState([]);


  useEffect(() => {
    const updatedReasons = [
      t("RAL0883"),
      t("RAL0884"),
      t("RAL0885"),
      t("RAL0886"),
      t("RAL0887"),
      t("RAL0888"),
    ];
    setReasons(updatedReasons);
  }, [i18n.language, t]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    } else if (e.key === "Escape" && open) {
      onClose();
    }
  };

  useEffect(() => {
    if (open) {
      window.addEventListener("keydown", handleKeyDown);
    } else {
      window.removeEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, selectedReasons, otherReason]);

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("backdrop")) {
      onClose();
    }
  };

  const handleSubmit = async () => {
    if (selectedReasons.length === 0) {
      setError(true);
      return;
    }

    if (
      selectedReasons.includes(t("RAL0888")) &&
      !otherReason.trim()
    ) {
      setError(true);
      return;
    }

    const finalReasons = selectedReasons.map((reason) =>
      reason === t("RAL0888") ? otherReason : reason
    );

    const payload = {
      cancelReason: finalReasons,
    };

    if (planInterval === "months" || planInterval === "years") {
      cancelSubscription(subscriptionId, payload)
        .then((res) => {
          if (res?.data?.code === "RCI0046") {
            console.log("Subscription cancelled successfully");
            subscriptionDetails.status = "cancelled";
            onClose();
            setTimeout(() => {
              if (onConfirm) {
                onConfirm();
              }
            }, 150);
          } else if (res?.data?.code === "RCE0253") {
            onClose();
            setTimeout(() => {
              if (onFailure) onFailure();
            }, 200);
          } else {
            console.error("Failed to cancel subscription:", res.data.code);
            onClose();
            setTimeout(() => {
              if (onFailure) onFailure();
            }, 200);
          }
        })
        .catch((error) => {
          console.error("Error updating plans:", error);
          onClose();
          setTimeout(() => {
            if (onFailure) onFailure();
          }, 200);
        });
    } else {
      console.error("Subscription ID is missing");
    }
  };

  const handleReasonChange = (reason) => {
    let updatedReasons = [...selectedReasons];

    if (updatedReasons.includes(reason)) {
      updatedReasons = updatedReasons.filter((r) => r !== reason);
    } else {
      updatedReasons.push(reason);
    }

    if (
      !updatedReasons.includes(t("RAL0888")) &&
      selectedReasons.includes(t("RAL0888"))
    ) {
      setOtherReason("");
    }
    setSelectedReasons(updatedReasons);
    setError(false);
  };

  const handleClose = () => {
    setSelectedReasons([]);
    setOtherReason("");
    onClose();
  };

  return (
    <>
      <div className="backdrop" onClick={handleBackdropClick}>
        <div
          className={`${
            mode === "dark" ? "Feedback-containerDark" : "Feedback-container"
          } ${
            selectedReasons.includes(t("RAL0888"))
              ? "show-description"
              : ""
          }`}
        >
          <span
            className={
              mode === "dark" ? "Feedback-titleDark" : "Feedback-title"
            }
          >
            {title}
          </span>
          <span
            className={
              mode === "dark"
                ? "horizontal-FeedbackDark"
                : "horizontal-Feedback"
            }
          ></span>
          <p
            className={
              mode === "dark" ? "Feedback-contentDark" : "Feedback-content"
            }
          >
            {content}
          </p>
          <div>
            <div className="reasons-container">
              {reasons.map((reason, index) => (
                <div
                  key={index}
                  className={mode === "dark" ? "radio-itemdark" : "radio-item"}
                  onClick={() => handleReasonChange(reason)}
                >
                  <Checkbox
                    className={`custom-radio ${
                      mode === "dark" ? "feedbackradiocolorDark" : "feeedbackradiocolor"
                    }`}
                    checked={selectedReasons.includes(reason)}
                    onChange={() => handleReasonChange(reason)}
                    value={reason}
                    name="feedback-reason"
                    sx={{
                      "&.Mui-checked": {
                        color: "orange",
                      },
                    }}
                  />
                  <span
                    className={
                      mode === "dark"
                        ? "radio-FeedbackLabelDark"
                        : "radio-FeedbackLabel"
                    }
                  >
                    {reason}
                  </span>
                </div>
              ))}
            </div>

            {/* {error && (
              <div>
                <span
                  className={
                    mode === "dark"
                      ? "error-FeedbackmessageDark"
                      : "error-Feedbackmessage"
                  }
                >
                  <ErrorIcon className="feedback-error-icon" />
                  {selectedReasons.includes(t("RAL0888")) &&
                  !otherReason.trim()
                    ? t("RAL0889")
                    : t("RAL0889")}
                </span>
              </div>
            )} */}

            {selectedReasons.includes(t("RAL0888")) && (
              <div
                className={
                  mode === "dark"
                    ? "description-containerDark"
                    : "description-container"
                }
              >
                <DescriptionInputFeedback
                  type="text"
                  className={
                    mode === "dark"
                      ? "Feedbackdescriptiondark"
                      : "Feedbackdescription"
                  }
                  label={t("RAL0989")}
                  value={otherReason}
                  error={error && selectedReasons.includes(t("RAL0888")) && !otherReason.trim()}
                  // onChange={(e) => setOtherReason(e.target.value)}
                  onChange={(e) => {
                    setOtherReason(e.target.value);
                    if (e.target.value.trim()) {
                      setError(false);
                    }
                  }}
                />
              </div>
            )}

           {error && (
              <div
              style={{
                paddingLeft: selectedReasons.includes(t("RAL0888")) && !otherReason.trim() ? "15px" : "0"
              }}
            >
                <span
                  className={
                    mode === "dark"
                      ? "error-FeedbackmessageDark"
                      : "error-Feedbackmessage"
                  }
                >
                  <ErrorIcon className="feedback-error-icon" />
                  {selectedReasons.includes(t("RAL0888")) &&
                  !otherReason.trim()
                    ? t("RAL0974")
                    : t("RAL0889")}
                </span>
              </div>
            )}
          </div>

          <div className="Feedback-buttons">
            <button
              className={
                mode === "dark"
                  ? "FeedbackcancelPop-buttonDark"
                  : "FeedbackcancelPop-button"
              }
              onClick={handleClose}
            >
              {cancelText}
            </button>
            <button
              className="FeedbackconfirmPop-button"
              onClick={handleSubmit}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeedbackPopup;